module.exports = __webpack_public_path__ + "img/1alB-lh-lhape'.e349234c.jpg";